<template>
    <footer id="footer">
        <div class="container p-0">
            <div class="footer_wrapper">
                <div class="footer_columns">
                    <div class="footer_column">
                        <router-link to="/" class="footer_logo">
                            <img :src="logo_url.value" alt="Logo" title="Logo">
                        </router-link>
                        <p>{{ footer_settings.footer_brief?.value }}</p>
                    </div>
                    <!-- <div class="footer_column">
                        <ul>
                            <li v-if="footer_settings.contact_mail">
                                <h5>{{ $t("mail") }}</h5>
                                <a :href="'mailto:' + footer_settings.contact_mail?.value"><b>{{
                                    footer_settings.contact_mail?.value }}</b></a>
                            </li>
                            <li v-if="footer_settings.contact_phone">
                                <h5>{{ $t("call") }}</h5>
                                <a class="tel" target="_blank"
                                    :href="'https://api.whatsapp.com/send/?phone=' + footer_settings.contact_phone?.value.replace(/\s/g, '')">
                                    <b>{{ footer_settings.contact_phone?.value }}</b>
                                    <font-awesome-icon :icon="'fa-brands fa-whatsapp'" />
                                </a>
                            </li>
                        </ul>
                    </div> -->
                    <div class="footer_column">
                        <h5>{{ $t("footer.useful_links") }}</h5>
                        <div class="menues_wrapper">
                            <div class="menu_wrapper">
                                <a v-for="link in footer_menu_1" :href="link.item_slug" target="_blank">{{ link.title
                                }}</a>
                            </div>
                            <div class="menu_wrapper">
                                <a v-for="link in footer_menu_2" :href="link.item_slug" target="_blank">{{ link.title
                                }}</a>
                            </div>
                        </div>
                    </div>
                    <div class="footer_column">
                        <h5>{{ $t("contact") }}</h5>
                        <div class="contact_info">
                            <a :href="footer_settings.contact_phone?.value.replace(/\s/g, '')" target="_blank">
                                <font-awesome-icon :icon="'fa-solid fa-phone'" />
                                {{ footer_settings.contact_phone?.value }}
                            </a>
                            <a :href="footer_settings.contact_mail?.value" target="_blank">
                                <font-awesome-icon :icon="'fa-solid fa-envelope'" />
                                {{ footer_settings.contact_mail?.value }}
                            </a>
                        </div>
                    </div>
                </div>
                <div class="rights">
                    <p>{{ footer_settings.copyright_text?.value }}</p>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import axios from 'axios'
import Button from "./Button.vue";
import { createToaster } from "@meforma/vue-toaster";
const toaster = createToaster({});
const base_url = process.env.VUE_APP_BASE_URL;

export default {
    name: 'Footer',
    components: {
        Button,
    },
    data: function () {
        return {
            logo_url: "",
            footer_settings: [],
            social_links: [],
            footer_menu_1: [],
            footer_menu_2: [],
        };
    },
    async mounted() {
        await Promise.all([
            this.get_footer_settings(),
            this.get_logo_img(),
            this.get_social_links(),
            this.get_menu_1(),
            this.get_menu_2()
        ]);
        await this.$nextTick()
        this.footerMargining();
    },
    methods: {
        get_footer_settings() {
            var params = {
                keys: [
                    'footer_heading',
                    'footer_brief',
                    'footer_menu_1',
                    'footer_menu_2',
                    'contact_mail',
                    'contact_phone',
                    'copyright_text'
                ],
                locale: process.env.VUE_APP_DEFAULT_LOCALE,
            };
            return axios
                .get(base_url + "/get_settings", { params: params })

                .then((response) => {
                    this.footer_settings = response.data.data;
                })
                .catch((error) => {
                    let res = error.response.data;
                });
        },
        get_logo_img() {
            return axios
                .get(base_url + "/get_setting/logo_image")
                .then((response) => {
                    this.logo_url = response.data.data;
                })
                .catch((error) => {
                    let res = error.response;
                    toaster.error(res.data.message);
                });
        },
        get_social_links() {
            var params = {
                slug: 'social_media',
                locale: process.env.VUE_APP_DEFAULT_LOCALE,
            };
            return axios
                .get(base_url + "/getSectionBySlug", { params: params })

                .then((response) => {
                    this.social_links = response.data.data.network.extra;
                })
                .catch((error) => {
                    let res = error.response.data;
                });
        },
        get_menu_1() {
            var params = {
                slug: "footer_menu_1",
                locale: process.env.VUE_APP_DEFAULT_LOCALE,
            };
            return axios
                .get(base_url + "/getMenuBySlug", { params: params })
                .then((response) => {
                    this.footer_menu_1 = response.data.data;
                })
                .catch((error) => {
                    let res = error.response;
                    toaster.error();
                });
        },
        get_menu_2() {
            var params = {
                slug: "footer_menu_2",
                locale: process.env.VUE_APP_DEFAULT_LOCALE,
            };
            return axios
                .get(base_url + "/getMenuBySlug", { params: params })
                .then((response) => {
                    this.footer_menu_2 = response.data.data;
                    footerMargining();
                })
                .catch((error) => {
                    let res = error.response;
                    toaster.error();
                });
        },
        footerMargining() {
            let footer = document.getElementById('footer');
            let innerContent = document.getElementById('app');
            innerContent.style.marginBottom = `${footer.offsetHeight}px`;
        }
    },

}
</script>

<style scoped>
footer {
    background-color: var(--secondaryColor);
    transition: 0.3s ease-in-out;
}

footer *:not(path) {
    color: white;
    line-height: 1.6;
}

.footer_wrapper {
    padding: 75px 20px 30px 20px;
}

.footer_wrapper .footer_columns {
    position: relative;
    display: flex;
    padding-bottom: 5px;
}

.footer_wrapper .footer_column {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 30px;
    padding: 20px;
}


.footer_wrapper .footer_column .footer_logo {
    display: flex;
    width: 150px;
}

.footer_wrapper .footer_column:has(.menues_wrapper) {
    gap: 25px;
}

.footer_wrapper .footer_column .menues_wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 15px;
}

.footer_wrapper .footer_column .menues_wrapper .menu_wrapper {
    display: flex;
    flex-direction: column;
}

.footer_wrapper .footer_column .menues_wrapper .menu_wrapper a {
    padding: 5px 0;
}

.footer_wrapper .footer_column .menues_wrapper .menu_wrapper a:hover {
    color: var(--mainColor);

}

.footer_wrapper .footer_column .contact_info {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.footer_wrapper .footer_column .contact_info a {
    display: flex;
    align-items: center;
    gap: 15px;
}

.footer_wrapper .footer_column .contact_info svg {
    color: var(--mainColor);
    font-size: 20px;
}

.footer_wrapper :where(h1, h2, h3, h4, h5, h6) {
    width: fit-content;
    font-size: 24px;
    font-weight: 700;
    line-height: 1.6;
    color: white !important;
    margin: 0;
    border-bottom: 3px solid var(--mainColor);
}

.footer_wrapper p {
    font-size: 14px;
    margin: 0;
}

.footer_wrapper ul {
    gap: 1rem;
    list-style: none;
    padding: 0;
    padding-left: 0.5rem;
    margin: 0;
}

.rights {
    text-align: center;
    border-top: 3px solid rgba(255, 255, 255, 0.1);
    margin-top: 30px;
    padding-top: 30px;
}

.rights p {
    font-size: 16px;
    margin: 0;
}

@media (max-width: 992px) {
    .footer_wrapper * {
        font-size: 14px;
    }

    footer .container {
        max-width: none;
    }

    .footer_wrapper {
        width: 100%;
        padding: 50px 20px 15px 20px;
    }

    .footer_wrapper .footer_columns {
        flex-direction: column;
        padding: 0;
    }

    .footer_wrapper .footer_column {
        padding: 10px 0;
        gap: 15px !important;
    }

    .footer_wrapper .footer_column:first-child {
        padding: 0 0 15px;
    }

    .footer_wrapper :where(h1, h2, h3, h4, h5, h6) {
        font-size: 18px;
    }

    .rights {
        padding-top: 15px;
    }

    .rights p {
        font-size: 14px;
    }
}

@media (max-width: 768px) {
    .footer_wrapper .footer_column .footer_logo {
        width: 100px;
    }

    .footer_wrapper *:not(h1, h2, h3, h4, h5, h6) {
        font-size: 12px;
    }

    .footer_wrapper .footer_column .contact_info svg {
        font-size: 15px;
    }
}
</style>